app.service('deliveryInputs', function (console, loading, deliveryValidateCity) {
	let $self, $form, $reservationTOInputs;

	function deliveryAddressSwitch(address) {
		console.log('deliveryAddressSwitch');
		$('#delivery-street').val(address.street);
		$('#delivery-house-number').val(address.houseNumber);
		$('#delivery-flat-number').val(address.flatNumber);
		$('#delivery-zip-code').val(address.zipCode);
		$('#delivery-city-name').val(address.city);
	}

	function receiverDataSwitch(data) {
		console.log('receiverDataSwitch');
		$('#receiver-firstname').val(data.firstname);
		$('#receiver-surname').val(data.surname);
		$('#receiver-phone').val(data.phone);
	}

	function validate(config) {

		if ($form.valid()) {
			loading.start();
			if (config.deliveryInfo.deliveryEqualsHome) {
				deliveryAddressSwitch({
					street: $('#home-street').val(),
					houseNumber: $('#home-house-number').val(),
					flatNumber: $('#home-flat-number').val(),
					zipCode: $('#zip-code').val(),
					city: $('#city-name').val()
				});
			}
			if (!config.deliveryInfo.invoiceNeeded && config.deliveryInfo.deliveryType === 'home') {	//jeśli potrzebna inna faktura i nie jest to distawa do sklepu
				invoiceAddressSwitch({
					addLine1: $('#firstname').val(),
					addLine2: $('#surname').val(),
					street: $('#home-street').val(),
					houseNumber: $('#home-house-number').val(),
					flatNumber: $('#home-flat-number').val(),
					zipCode: $('#zip-code').val(),
					countryCode: $('#country-code').val(),
					city: $('#city-name').val(),
					companyName: $('#company-name-textarea-div').text(),
					nip: $('#nip').val()
				});
			}
			deliveryValidateCity.validate(config);
		} else {
			console.log('formularz ma błędy', $('.error'));
		}
	}

	function checkReservation(forceReservation) {
		if (forceReservation) {
			$reservationTOInputs.disabled(true);
			$self.addClass('reservation-enabled');
		} else {
			$reservationTOInputs.disabled(false);
			$self.removeClass('reservation-enabled');
		}
	}

	function setElements() {
		$form = $('#choose-delivery-form', $self);
		if ($('.insurer-warranties-box').length) {
			$reservationTOInputs = $('#home-address-details', $form).find('textarea, input');	// inputy które należy wyłączyć/wyłączyć jak operator zaznacza "rezerwację"
		} else {
			$reservationTOInputs = $('.user-type-info, .user-type-info, .invoice-data-form, #home-address-details', $form).find('textarea, input').not('[name="invoice.invoiceNeeded"]');	// inputy które należy wyłączyć/wyłączyć jak operator zaznacza "rezerwację"
		}
	}

	function init(self) {
		$self = self;
		setElements();
	}
	return {
		init,
		checkReservation,
		deliveryAddressSwitch,
		receiverDataSwitch,
		validate
	};
});
